<template>
  <div>
    <nav class="navbar navbar-expand-lg navigation fixed-top sticky" id="navbar">
      <div class="container">
        <a class="navbar-logo" href="/help-center">
          <img src="@/assets/images/logo.png" height="50" class="logo logo-dark" />
          <img src="@/assets/images/logo-white.png" height="50" class="logo logo-light" />
        </a>

        <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" data-toggle="collapse" data-target="#topnav-menu-content" @click="toggleMenu()">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav ml-auto" id="topnav-menu" v-scroll-spy-active="{ selector: 'a.nav-link' }">
            <li class="nav-item">
              <router-link class="nav-link" to="/help-center/about" v-scroll-to="'#about'">
                {{ $t("help.about-platform") }}
              </router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/help-center/platform" v-scroll-to="'#app'">
                {{ $t("help.title") }}
              </router-link>
            </li>
          </ul>

          <div v-if="!user" class="ml-lg-2">
            <a href="/login" target="_blank" class="btn btn-outline-success w-xs">
              {{ $t("account.login.text") }}
            </a>
          </div>
          <div v-else class="text-success">
            <div class="avatar-xs float-left">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-success
                  text-success
                  font-size-16
                "
              >
                {{ userLetterAvatar }}
              </span>
            </div>

            <span class="d-none d-xl-inline-block ml-1 mt-2">
              {{ user.name }}
            </span>
          </div>
        </div>
      </div>
    </nav>
    <div v-scroll-spy>
      <!-- hero section start -->
      <section class="section hero-section bg-ico-hero" id="home">
        <div class="bg-overlay bg-custom-primary" :class="typingStarted ? 'bg-danger' : ''"></div>
        <div v-if="!typingStarted" class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="text-white-50">
                <h1 class="text-white font-weight-semibold mb-1 hero-title">
                  {{ $t("help.title") }}
                </h1>
                <h2 class="text-white mb-3">
                  {{ $t("help.management") }}
                </h2>
                <p class="font-size-14">
                  {{ $t("help.welcome") }}
                </p>

                <div class="button-items mt-4">
                  <a href="/" target="_blank" class="btn btn-success">{{ $t("help.go-to-app") }}</a>

                  <router-link class="btn btn-light" v-scroll-to="'#about'" to="/help-center/about">
                    {{ $t("help.about") }}
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-8 col-sm-10 ml-lg-auto">
              <h2 class="text-white mb-3">{{ $t("help.call") }}</h2>

              <div class="search-box mr-2">
                <div class="position-relative">
                  <input @click="typingStart" type="text" class="form-control border-0 p-4" :placeholder="$t('common.search')" style="padding-left: 50px !important" />
                  <i class="bx bx-search-alt search-icon font-size-22 mt-1"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <!-- end container -->

        <div v-if="typingStarted" class="container">
          <div class="col-lg-12">
            <h2 class="text-white mb-3">{{ $t("help.call") }}</h2>

            <div class="search-box mr-2">
              <div class="position-relative">
                <input
                  ref="searchInput"
                  v-model="term"
                  @keydown.esc="typingStarted = false"
                  type="text"
                  class="form-control border-0 p-4"
                  :placeholder="$t('common.search')"
                  style="padding-left: 50px !important"
                />
                <i class="bx bx-search-alt search-icon font-size-22 mt-1"></i>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- hero section end -->
      <!-- currency price section start -->
      <section class="section bg-white p-0">
        <div class="container">
          <div class="currency-price">
            <div class="row">
              <div class="col-md-4">
                <a href="javascript:;" @click="gotoPage('/help-center/faqs')" v-scroll-to="'#faqs'">
                  <div class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="avatar-xs mr-3">
                          <span
                            class="
                              avatar-title
                              rounded-circle
                              bg-soft-primary
                              text-primary
                              font-size-18
                            "
                          >
                            <i class="bx bxs-help-circle"></i>
                          </span>
                        </div>
                        <div class="media-body">
                          <h5 class="mt-2">
                            {{ $t("help.faqs.frequently-asked-questions.title") }}

                            <i class="fa fa-arrow-right float-right"> </i>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-4">
                <a href="javascript:;" @click="gotoPage('/help-center/platform')" v-scroll-to="'#app'">
                  <div class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="avatar-xs mr-3">
                          <span
                            class="
                              avatar-title
                              rounded-circle
                              bg-soft-info
                              text-info
                              font-size-18
                            "
                          >
                            <i class="bx bx-compass"></i>
                          </span>
                        </div>
                        <div class="media-body">
                          <h5 class="mt-2">
                            {{ $t("help.platform.text") }}
                            <i class="fa fa-arrow-right float-right"> </i>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-4">
                <a href="javascript:;" @click="gotoPage('/help-center/support')" v-scroll-to="'#support'">
                  <div class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="avatar-xs mr-3">
                          <span
                            class="
                              avatar-title
                              rounded-circle
                              bg-soft-warning
                              text-warning
                              font-size-18
                            "
                          >
                            <i class="bx bx-support"></i>
                          </span>
                        </div>
                        <div class="media-body">
                          <h5 class="mt-2">
                            {{ $t("help.contact") }}
                            <i class="fa fa-arrow-right float-right"> </i>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
        <!-- end container -->
      </section>
      <div v-if="!typingStarted">
        <router-view />
      </div>
      <div v-else class="bg-white">
        <section class="section pt-1 bg-white">
          <div class="container">
            <h1>{{ $t("help.search-result") }}</h1>
            <hr />
            <div v-if="anyResult" class="row">
              <div v-if="result.faq && result.faq.length" class="col-lg-6">
                <h3>{{ $t("help.faqs.frequently-asked-questions.title") }} ({{ result.faq.length }})</h3>
                <ul>
                  <li v-for="item in result.faq" :key="item.title">
                    <a href="javascript:;" @click="gotoPage(item.location)"> {{ item.title }}</a>
                  </li>
                </ul>
              </div>
              <div v-if="result.app && result.app.length" class="col-lg-6">
                <h3>{{ $t("help.app-usage") }} ({{ result.app.length }})</h3>
                <ul>
                  <li v-for="item in result.app" :key="item.title">
                    <a href="javascript:;" @click="gotoPage(item.location)"> {{ item.title }}</a>
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="!anyResult">
              <b-alert show variant="secondary">
                <b>"{{ term }}"</b> {{ $t("help.no-result-found-for") }}
              </b-alert>
            </div>
          </div>
        </section>
      </div>

      <!-- Footer start -->
      <footer class="landing-footer">
        <div class="container">
          <div class="row"></div>
          <!-- end row -->

          <div class="row">
            <div class="col-lg-6">
              <div class="mb-4">
                <img src="@/assets/images/logo-white.png" alt height="40" />
              </div>
              <p class="mb-2">{{ new Date().getFullYear() }} © Tune Soft</p>
              <p>
                powered by
                <a href="https://phexum.com?ref=tunesoft" target="_blank">
                  <img src="@/assets/images/phexum-logo-white.png" alt height="20" />
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import TermDb from "./term-db";

export default {
  components: {},
  data() {
    return { typingStarted: false, term: undefined, result: {} };
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  computed: {
    anyResult() {
      const r = this.result;
      return (!!r.faq && !!r.faq.length) || (!!r.app && !!r.app.length);
    },
    userLetterAvatar() {
      const account = this.currentAccount;
      if (!account) {
        return;
      }
      const arr = account.name.split(" ");
      const avatar = [];
      for (const [i, value] of arr.entries()) {
        avatar.push(value.charAt(0));
        if (i == 1) {
          break;
        }
      }
      return avatar.join("");
    },
    user() {
      return this.currentAccount;
    },
  },
  watch: {
    term(v, o) {
      this.result = TermDb.search(v, this.currentLanguage);
    },
  },
  mounted() {},
  methods: {
    gotoPage(page) {
      this.typingStarted = false;
      this.$router.push(page).catch(() => {});
    },
    typingStart() {
      this.typingStarted = true;
      this.$nextTick(() => this.$refs.searchInput.focus());
    },
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },
  },
};
</script>
<style>
.bg-custom-primary {
  background-color: #3449ab !important;
}
</style>
